<template>
  <ion-page>
    <ion-content>
      <div class="navbar" style="margin-bottom: 22px">
        <img class="nav-icon" :src="getBrandImageUrl('xiaoyu.png')" alt="" @click="doBack" />
        修改密码
      </div>
      <div class="ipt-box">账号：{{ dataForm.account }}</div>
      <div class="ipt-box">
        <img :src="getBrandImageUrl('login1.png')" alt="" />
        <ion-input
          v-model="dataForm.phone"
          type="text"
          disabled
          placeholder="请输入手机号"
          maxlength="11"
          class="input"
        >
        </ion-input>
      </div>
      <div class="ipt-box">
        <img :src="getBrandImageUrl('register3.png')" alt="" />
        <ion-input
          v-model="dataForm.verificationCode"
          type="text"
          placeholder="请输入验证码"
          maxlength="4"
          class="input"
        >
        </ion-input>
        <div class="code-label" @click="getSMSCode">{{ RegCodeLabel }}</div>
      </div>
      <div class="ipt-box">
        <img :src="getBrandImageUrl('login2.png')" alt="" />
        <ion-input
          v-model.trim="dataForm.password"
          class="input"
          :type="typeList[0] ? 'text' : 'password'"
          label="旧密码"
          placeholder="旧密码"
          maxlength="20"
        ></ion-input>
        <img
          v-if="!typeList[0]"
          :src="getBrandImageUrl('login3.png')"
          alt=""
          @click="typeList[0] = true"
        />
        <img v-else :src="getBrandImageUrl('login4.png')" alt="" @click="typeList[0] = false" />
      </div>
      <div class="ipt-box">
        <img :src="getBrandImageUrl('login2.png')" alt="" />
        <ion-input
          v-model.trim="dataForm.newPassword"
          class="input"
          :type="typeList[1] ? 'text' : 'password'"
          label="新密码"
          placeholder="新密码，长度6~20位"
          maxlength="20"
          @ionChange="handlePasswordChange"
        ></ion-input>
        <img
          v-if="!typeList[1]"
          :src="getBrandImageUrl('login3.png')"
          alt=""
          @click="typeList[1] = true"
        />
        <img v-else :src="getBrandImageUrl('login4.png')" alt="" @click="typeList[1] = false" />
      </div>
      <div v-if="passwordStrength > 0" class="strength-meter-bar">
        <div
          class="strength-meter-bar--fill"
          :style="{ width: passwordStrength + '%', 'background-color': calcProgressColor() }"
        ></div>
      </div>
      <div class="ipt-box">
        <img :src="getBrandImageUrl('login2.png')" alt="" />
        <ion-input
          v-model.trim="dataForm.confirmPassword"
          :type="typeList[2] ? 'text' : 'password'"
          label="确认密码"
          placeholder="确认密码"
          maxlength="20"
        ></ion-input>
        <img
          v-if="!typeList[2]"
          :src="getBrandImageUrl('login3.png')"
          alt=""
          @click="typeList[2] = true"
        />
        <img v-else :src="getBrandImageUrl('login4.png')" alt="" @click="typeList[2] = false" />
      </div>
      <div class="btn" @click="submitForm">确定</div>
    </ion-content>
  </ion-page>
</template>

<script>
import { IonContent, IonInput, IonPage, modalController } from "@ionic/vue"
import { getBrandImageUrl } from "@/js/brandImages"
import { doEncrypt } from "@/js/sm"
import store from "@/js/store"
import { nextTick } from "vue"

export default {
  name: "ResetPassword",
  components: {
    IonPage,
    IonContent,
    IonInput,
  },
  props: ["phone", "account"],
  data() {
    return {
      //###############  短信验证 - 开始 ##############
      remainTime: 60,
      tickTimer: undefined, //短信发送倒计时定时器
      RegCodeLabel: "获取验证码",
      sendButtonEnable: true, //发生验证码按钮是否可用
      //###############  短信验证 - 结束 ##############
      typeList: [false, false, false],
      dataForm: {
        phone: undefined,
        verificationCode: undefined,
      },
      userInfo: {},
      passwordStrength: 0,
      percent1: 0,
      percent2: 0,
      percent3: 0,
    }
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("userinfo"))
    this.dataForm.phone = this.phone || this.userInfo.phone
    this.dataForm.account = this.account || this.userInfo.account
  },
  methods: {
    getBrandImageUrl,
    handlePasswordChange(e) {
      const len = e.target.value.length
      let percent1 = 0
      let percent2 = 0
      let percent3 = 0

      if (len < 7) {
        percent1 = (len / 6) * 33.33
      } else if (len < 15) {
        percent1 = 33.33 // 第一段已满
        percent2 = ((len - 6) / 8) * 33.33
      } else {
        percent1 = 33.33 // 第一段已满
        percent2 = 33.33 // 第二段已满
        percent3 = ((len - 14) / 6) * 33.33
      }

      this.passwordStrength = Math.min(percent1 + percent2 + percent3, 100)
      console.log(e, this.passwordStrength)
    },
    calcProgressColor() {
      return this.passwordStrength <= 33.33
        ? "#e74242"
        : this.passwordStrength <= 66.66
          ? "#efbd47"
          : "#55d187"
    },
    //验证手机号码
    checkPhone() {
      const phone = this.dataForm.phone

      if (phone == undefined || phone.trim() === "") {
        this.errorMsg = "手机号码不能为空！"
        return false
      }

      if (!/^1[3-9]\d{9}/.test(phone)) {
        this.errorMsg = "手机号码格式错误！"
        return false
      }

      return true
    },

    checkCode() {
      const verificationCode = this.dataForm.verificationCode

      if (verificationCode == undefined || verificationCode.trim() === "") {
        this.errorMsg = "验证码不能为空！"
        return false
      }

      return true
    },

    getSMSCode() {
      if (!this.checkPhone()) {
        this.alert(this.errorMsg)
        return
      }
      if (!this.sendButtonEnable) {
        return
      }
      this.ajax.post("/sendResetPasswordCode?phone=" + this.dataForm.phone).then((res) => {
        if (res.data.success) {
          this.remainTime = 60
          this.sendButtonEnable = false

          this.tickTimer = setInterval(() => {
            this.remainTime--
            this.RegCodeLabel = "获取验证码（" + this.remainTime + "）"
          }, 1000)

          //设定60秒解除锁定，以防连续发送
          setTimeout(() => {
            clearInterval(this.tickTimer)
            this.RegCodeLabel = "获取验证码"
            this.sendButtonEnable = true
          }, 1000 * 60)

          this.alert("验证码已发送，请注意查收！")
        }
      })
    },

    doBack() {
      store.clearSession()
      location.replace("/login")
    },

    submitForm() {
      if (!this.checkPhone()) {
        this.alert(this.errorMsg)
        return
      }

      if (!this.checkCode()) {
        this.alert(this.errorMsg)
        return
      }

      if (!this.dataForm.password) {
        this.alert("请输入旧密码。")
        return
      }

      if (!this.dataForm.newPassword) {
        this.alert("请输入新密码。")
        return
      }

      const regx = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,20}$/
      if (!regx.test(this.dataForm.newPassword)) {
        this.alert("密码需6~20位，由数字和字母组成，且不可包含完整手机号或完整账号信息")
        return
      }
      if (
        this.dataForm.newPassword.includes(this.dataForm.account) ||
        this.dataForm.newPassword.includes(this.dataForm.phone) ||
        this.dataForm.newPassword.toLowerCase().includes(this.dataForm.account.toLowerCase())
      ) {
        this.alert("新密码不能包含账号或手机号")
        return
      }
      if (!this.dataForm.confirmPassword) {
        this.alert("请输入确认密码。")
        return
      }

      if (this.dataForm.newPassword !== this.dataForm.confirmPassword) {
        this.alert("密码不一致。")
        return
      }

      this.dataForm.systemType = "app"
      this.ajax
        .post(
          "/resetPasswordV1",
          Object.assign({}, this.dataForm, {
            confirmPassword: undefined,
            password: doEncrypt(this.dataForm.password),
            newPassword: doEncrypt(this.dataForm.newPassword),
            account: doEncrypt(this.dataForm.account),
          })
        )
        .then((res) => {
          if (res.data.success) {
            if (this.userInfo.userType == 2) {
              location.replace("/TeacherIndex")
            } else {
              location.replace("/StudentIndex")
            }
          }
        })
    },
  },
}
</script>
<style scoped lang="less">
ion-content {
  --background: #fff !important;
}
.navbar {
  height: 44px;
  line-height: 44px;
  text-align: center;
  position: relative;
}
.nav-icon {
  width: 24px;
  height: 24px;
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translate(0, -50%);
}
.ipt-box {
  width: 89.33vw;
  height: 2.8rem;
  border-radius: 8px;
  background: #f5f5f5;
  margin: auto;
  padding: 0 16px;
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
.ipt-box2 {
  width: 89.33vw;
  border-radius: 8px;
  /* background:#F5F5F5; */
  margin: auto;
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
.ipt-box img {
  width: 16px;
  height: 16px;
}
.input {
  line-height: 44px;
  flex: 1;
  height: 44px;
}
.btn {
  width: 81.33vw;
  border-radius: 25px;
  height: 44px;
  line-height: 44px;
  background: var(--theme-color);
  color: #fff;
  font-size: 17px;
  text-align: center;
  margin: 30px auto;
}
.item-box {
  width: 100%;
}
.radio {
  margin: 0 10px 0 0;
}

.strength-meter-bar {
  width: 89.33vw;
  position: relative;
  height: 6px;
  margin: -6px auto 10px;
  border-radius: 6px;
  background-color: rgb(0 0 0 / 25%);

  // 增加的伪元素样式代码
  &::before,
  &::after {
    content: "";
    display: block;
    position: absolute;
    z-index: 10;
    height: inherit;
    border-width: 0 5px;
    border-style: solid;
    border-color: #fff;
    background-color: transparent;
  }
  &::before {
    left: 33.33%;
  }
  &::after {
    right: 33.33%;
  }
  // 增加的伪元素样式代码

  &--fill {
    position: absolute;
    height: inherit;
    transition:
      width 0.5s ease-in-out,
      background 0.25s;
    border-radius: inherit;
    background-color: transparent;
  }
}
</style>
